// import qs from 'qs';

const state = {

    docs:{},

    docs_check:{},

    contact_info:{
        "name": {
            "firstName": "",
            "otherName": ""
            },
            "genderCode": "M",
            "nid": {
            "nationalIdenNumber": "27906250103655"
            }, 
            "contactDetails": {
                "address": "Home",
                "mobile1": "",
                "mobile2": "01277377738",
                "email": ""
            },
            "motherFullName": "M"
    },

    user:{
          'fullName': '',
          'motherName':'',
          'gender':'',
          'copies':'',
          'relationship': '',
          'NID':'',
    },
    deliveryUser:{
        govCode: Number,
        address: String,
        RequesterFullName: String,
        email: String,
        mobile1: String,
        mobile2: String,
    },
    options : {
        headers: {'correlationId':1,
                  'originatingChannel':1,
                  'channelRequestId':1,
                  'originatingUserType':1,
                  'originatingUserIdentifier':1,
                  'serviceEntityId': 1,
                  'serviceSlug':1,
                  'responseCode':1,
                  'previewOnly':false,
                //   'email': sessionStorage.email,
                //   'token': sessionStorage.Token       
                },
        // params: qs.stringify({
        //           'email': sessionStorage.email,
        //           'token': sessionStorage.Token
        //         })
    },
    

};

const getters = {
    StateUser: (state) => state.user,
    StateDeliveryUser: (state) => state.deliveryUser,
    StateDocs: (state) => state.docs,
    StateBirthDocsChecked: (state) => state.docs_check,
    StateOptions: (state) => state.options,
    StateContact: (state) => state.contact_info, 
};



const actions = {

    saveDeliveryUser({commit},data){
        commit('setDeliveryUser',data);
        
    },

    saveDocs({commit},data){
        commit('setDocs',data);
        
    },

    deleteDoc({commit},requestNo){
        commit('deleteDoc',requestNo);
    },

    resetDocs({commit}){
        commit('resetDocs');
    },

    resetDefaultOptions({commit}) {
        commit('resetOptions');
    }
    
};

const mutations = {
     
    setUser(state, user) {
      state.user = user;
    },

    setDeliveryUser(state, deliveryUser) {
        state.deliveryUser = deliveryUser;
    },

    setDocs(state,data) {
        state.docs[data.reqNo] = data.document;
        state.docs_check[data.reqNo] = data.checked;
    },

    deleteDoc(state,reqNo) {
        delete state.docs[reqNo]; 
    },

    resetDocs(state)  {
        state.docs = {} ;
        state.docs_check = {};
    },

    resetOptions(state) {
        state.options = {
            headers: {'correlationId':1,
                      'originatingChannel':1,
                      'channelRequestId':1,
                      'originatingUserType':1,
                      'originatingUserIdentifier':1,
                      'serviceEntityId': 1,
                      'serviceSlug':1,
                      'responseCode':1,
                      'previewOnly':false,  
                      'email': sessionStorage.Email,
                      'token': sessionStorage.Token           
                        },
            params: {
                      'email': sessionStorage.email,
                      'token': sessionStorage.Token
                    }
            };
    }

    
}


export default{
    state,
    getters,
    actions,
    mutations
}